function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.436 18.66l-.504-2.518a2.31 2.31 0 00-.855-1.41c-.277-.226-.553-.377-.83-.428l-2.138-.63c-.05-.024-.1-.024-.126-.05a.56.56 0 01-.2-.327l-.101-.856a3.589 3.589 0 001.257-1.989c.378-.025.68-.453.68-1.007 0-.503-.252-.906-.604-.981M9.979 8.439c-.327.1-.579.503-.579.982 0 .528.302.956.68 1.007.226.805.653 1.51 1.257 1.989l-.1.83a.56.56 0 01-.202.328c-.05.025-.075.05-.126.05l-2.138.63c-.276.05-.553.2-.83.427-.427.353-.73.856-.855 1.41l-.503 2.518",
  stroke: "#D60000",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.015 8.439s.176-3.55-3.018-3.55c-3.195 0-3.044 3.575-3.044 3.575",
  stroke: "#D60000",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.205 6.928c.126-.251.377-.453.629-.553.427-.152.93-.026 1.333.15.604.277 1.132.605 1.811.68.654.076 1.232 0 1.811-.302M11.035 13.6l1.962 2.039M14.984 13.6l-1.988 2.039M12.996 15.639v1.36",
  stroke: "#D60000",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.997 24.55c6.626 0 11.997-5.377 11.997-12.008C24.994 5.91 19.623.534 12.997.534 6.371.534 1 5.91 1 12.542c0 6.631 5.371 12.007 11.997 12.007zM13.324 26.639c7.596 0 13.758-6.168 13.758-13.77",
  stroke: "#D60000",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M24.114 21.403l6.414 6.42c.629.629.629 1.636 0 2.24-.629.63-1.635.63-2.239 0l-6.439-6.395",
  stroke: "#D60000",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

function SvgInfoRed1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoRed1);
export default __webpack_public_path__ + "static/media/info-red1.3fbe02d6.svg";
export { ForwardRef as ReactComponent };